import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Card, Flex, Typography, theme } from 'antd'
import PriceDescription from './price-description'
import PriceDisplay from './price-display'
import RecommendationTag from './recommendation-tag'

const { Text, Title } = Typography

const PlanCard = ({ plan = {}, style }) => {
  const { token } = theme.useToken()
  const {
    name,
    description,
    price,
    period,
    price_description,
    features,
    unavailableFeatures = [],
    recommended,
  } = plan

  const featuresList = features?.map((feature, index) => {
    const isUnavailable = unavailableFeatures.includes(feature)

    return (
      <li
        key={`${feature.substring(0, 10)}-${index}`}
        style={{
          listStyle: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: token.fontSize,
          fontFamily: token.fontFamily,
          color: isUnavailable ? token.colorError : token.colorText,
        }}
      >
        {isUnavailable ? (
          <CloseOutlined style={{ color: token.colorError }} />
        ) : (
          <CheckOutlined style={{ color: token.colorSuccess }} />
        )}
        <span>{feature}</span>
      </li>
    )
  })

  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderColor: recommended
      ? token.colorPrimary
      : token.colorBorderSecondary,
    ...style,
  }

  const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: token.paddingLG,
  }

  return (
    <Card style={cardStyle} styles={{ body: bodyStyle }}>
      {recommended && <RecommendationTag />}

      <Flex vertical style={{ flex: 1 }}>
        <Title
          level={4}
          style={{
            fontFamily: 'Sora, sans-serif',
            fontSize: token.fontSizeHeading4,
            fontWeight: token.fontWeightStrong,
            margin: 0,
            marginBottom: token.marginXS,
          }}
        >
          {name}
        </Title>
        <Text
          style={{
            color: token.colorTextDescription,
            fontFamily: token.fontFamily,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            marginBottom: token.marginLG,
          }}
        >
          {description}
        </Text>

        <ul
          style={{
            paddingLeft: 0,
            margin: 0,
            marginBottom: token.marginLG,
            display: 'flex',
            flexDirection: 'column',
            gap: token.marginXS,
          }}
        >
          {featuresList}
        </ul>
      </Flex>

      <Flex vertical gap={token.marginMD}>
        <Flex align="center" gap={token.marginMD}>
          <PriceDisplay price={price} period={period} />
          <PriceDescription description={price_description} />
        </Flex>
      </Flex>
    </Card>
  )
}

export default PlanCard
